import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { onBookFlights } from '../../../redux/actions/FlightsUiActions';
import { trackFlightBookButtonPress } from '../../../redux/actions/analyticsEventActions';
import { SemiTransparentLoader } from '../../../components';

function BookFlights(props) {
  const [isLoading, setIsLoading] = React.useState(false);
  const {
    bookFlights,
    flightId,
    returnFlightId,
    location: { pathname, search },
    history,
    children,
    sessionId,
  } = props;

  async function handleBook() {
    setIsLoading(true);

    try {
      await bookFlights(flightId, returnFlightId, sessionId);
      props.trackFlightBookButtonPress();
      history.push({
        pathname: `${pathname}/passenger-details`,
        search,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <React.Fragment>
      <SemiTransparentLoader
        isLoading={isLoading}
        loadingText="RESERVING YOUR FLIGHTS"
      />
      {children({ handleBook })}
    </React.Fragment>
  );
}

const mapDispatchToProps = dispatch => ({
  bookFlights: (flightId, returnFlightId, sessionId) =>
    dispatch(onBookFlights(flightId, returnFlightId, sessionId)),
    trackFlightBookButtonPress: () => dispatch(trackFlightBookButtonPress()),
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(BookFlights)
);



// WEBPACK FOOTER //
// ./src/screens/Flights/Common/BookFlights.js